import { useMemo } from 'react'

import {
  buildResourceFieldCatalog,
  IResourceFieldCatalogProperty,
} from './buildResourceFieldCatalog'

export function useResourceFieldCatalog({
  resourceTypeId,
  properties,
}: {
  resourceTypeId?: string
  properties?: IResourceFieldCatalogProperty[] | null
}) {
  return useMemo(
    () => buildResourceFieldCatalog(resourceTypeId, properties),
    [resourceTypeId, properties],
  )
}
